type HeaderApiItem = {
  data?: {
    header?: {
      cta?: {
        key?: string;
        path?: string;
        content?: {
          type?: string;
          label?: string;
        };
        visible?: boolean;
      };
      key?: string;
      logo?: {
        image?: {
          src?: string;
          visible?: boolean;
        };
        visible?: boolean;
      };
      type?: string;
      flags?: {
        sticky?: boolean;
      };
      title?: string;
      author?: string;
      status?: string;
      visible?: boolean;
      navigation?: {
        items?: Array<{
          key?: string;
          path?: string;
          label?: string;
          visible?: boolean;
        }>;
        visible?: boolean;
      };
    };
  };
};

export type NormalizedHeader = {
  page: "header";
  title: string;
  visible: boolean;
  sticky: boolean;
  logo: {
    src: string;
    visible: boolean;
  };
  cta: {
    path: string;
    type: string;
    label: string;
    visible: boolean;
  };
  navigation: {
    visible: boolean;
    items: Array<{
      key: string;
      label: string;
      path: string;
      visible: boolean;
    }>;
  };
  meta: {
    status: string;
    type: string;
    key: string;
    author?: string;
  };
};

export function normalizeHeader(item: HeaderApiItem): NormalizedHeader | null {
  const header = item?.data?.header;

  if (!header) return null;

  return {
    page: "header",
    title: header.title ?? "",
    visible: Boolean(header.visible),
    sticky: Boolean(header.flags?.sticky),

    logo: {
      src: header.logo?.image?.src ?? "",
      visible: Boolean(header.logo?.image?.visible ?? header.logo?.visible),
    },

    cta: {
      path: header.cta?.path ?? "",
      type: header.cta?.content?.type ?? "text",
      label: header.cta?.content?.label ?? "",
      visible: Boolean(header.cta?.visible),
    },

    navigation: {
      visible: Boolean(header.navigation?.visible),
      items: (header.navigation?.items ?? []).map((nav) => ({
        key: nav.key ?? "",
        label: nav.label ?? "",
        path: nav.path ?? "",
        visible: Boolean(nav.visible),
      })),
    },

    meta: {
      status: header.status ?? "",
      type: header.type ?? "",
      key: header.key ?? "",
      author: header.author,
    },
  };
}